// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var onboardee_uuid = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "onboardee_uuid"), null));
  if (onboardee_uuid.TAG === /* Ok */0) {
    var waitlist_ended_at = Decco.optionFromJson(Timestamp$Catalyst.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waitlist_ended_at"), null));
    if (waitlist_ended_at.TAG === /* Ok */0) {
      var waitlist_reason = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waitlist_reason"), null));
      if (waitlist_reason.TAG === /* Ok */0) {
        var waitlisted_at = Decco.optionFromJson(Timestamp$Catalyst.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waitlisted_at"), null));
        if (waitlisted_at.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    onboardee_uuid: onboardee_uuid._0,
                    waitlist_ended_at: waitlist_ended_at._0,
                    waitlist_reason: waitlist_reason._0,
                    waitlisted_at: waitlisted_at._0
                  }
                };
        }
        var e = waitlisted_at._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".waitlisted_at" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = waitlist_reason._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".waitlist_reason" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = waitlist_ended_at._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".waitlist_ended_at" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = onboardee_uuid._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".onboardee_uuid" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

export {
  t_decode ,
  
}
/* Timestamp-Catalyst Not a pure module */
